
;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

var bgX = moment.defineLocale('bg-x', {
    parentLocale: 'bg'
});

return bgX;

})));



//////////////////
// WEBPACK FOOTER
// ./~/moment/locale/bg-x.js
// module id = 588
// module chunks = 4